import keyMirror from 'keymirror';

const SEAT_UPGRADE_TYPES = keyMirror({
  AMPLUS_UPGRADE: null,
  EXIT_ROW_UPGRADE: null,
  PREFERRED_UPGRADE: null,
  FIRST_UPGRADE: null,
  SEAT_SELECTION_FEE: null,
});

export default SEAT_UPGRADE_TYPES;
